import React, { useEffect } from 'react';
import { View, ScrollView } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { scale } from '@components/frame';
import { subStatusName } from '@helpers';
import { getBoxShadowStyle } from '@styles/shadow';

import { getMachines } from '@reducers/machines';
import Line from '@components/common/line';
import { SCREEN_BORDER_RADIUS, SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';

const Machines = ({ C, getMachines, machines = [], navigation }) => {
  useEffect(() => {
    getMachines();
  }, []);

  const machinesFormatted = machines.map((m) => {
    const { machineConnection = {}, machineStatus = {}, fullName } = m;
    const status = i18n.t(subStatusName[machineStatus.subStatus] || '');
    const file = machineStatus.ncFile || '';
    return {
      name: fullName,
      bottom: `${status} ${status && file && '- ' + file}`,
      value: machineStatus.isConnected && machineConnection.switchedOn ? 'Connected' : 'Not Connected',
      onClick: () => {
        navigation.navigate('Settings', {
          screen: 'Machines',
          params: {
            screen: 'MachineDetails',
            params: { id: m.machineId },
          },
        });
      },
    };
  });

  return (
    <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50), paddingTop: scale(2) }}>
      <View
        style={{
          paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL),
        }}
      >
        <View
          style={[getBoxShadowStyle({type: 'Field', C}), {
            borderRadius: scale(SCREEN_BORDER_RADIUS),
          }]}
        >
          
          {machinesFormatted.map((i, index) => (
            <Line
              key={index}
              {...{
                item: i,
                index,
                array: machinesFormatted,
                bigSize: true,
                C,
                topBorder: index !== 0,
                roundTop: index === 0,
                roundBottom: index === machinesFormatted.length - 1,
                valueColor: i.value === 'Connected' ? 'System/Light/Green' : 'Label/Light/Error',
              }}
            />
          ))}
        </View>
      </View>
    </ScrollView>
  );
};

export default connect(({ machines: { machines, machinesLoaded } }) => ({ machines, machinesLoaded }), {
  getMachines,
})(Machines);
